import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {ConfigService} from '../../../core/services/config.service';
import {RequestService} from '../../../core/services/request.service';
import {VenueDetails} from './components/add/venue-add-details.model';

@Injectable()
export class VenuesService {

    constructor(
        private configService: ConfigService,
        private requestService: RequestService
    ) { }

    getVenueDetails(id: string): Observable<VenueDetails> {
        let url = this.configService.get('server').url +
            this.configService.get('endpoints').solar.address.details.api + '/' + id;
        return this.requestService.get(url);
    }

    deleteVenues(details: Array<any>): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.address.bulkDelete.api;
        return this.requestService.post(url, details);
    }

    getVenueGridFields(): any[] {
        return [
            {
                title: 'Venue Name',
                name: 'name',
                sortable: true
            },
            {
                title: 'Room Name',
                name: 'room',
                sortable: true
            },
            {
                title: 'Address',
                name: 'address',
                sortable: true
            },
            {
                title: 'City',
                name: 'city',
                sortable: true
            },
            {
                title: 'State',
                name: 'state',
                sortable: true
            },
            {
                title: 'Province',
                name: 'province',
                sortable: true
            },
            {
                title: 'Country',
                name: 'country',
                sortable: true
            },
            {
                title: 'Postal Code',
                name: 'postalCode',
                sortable: true
            },
            {
                title: 'Actions',
                config: {
                    type: 'action',
                    actions: [
                        { name: 'edit', label: 'Edit', icon: 'fa-edit' }
                    ]
                }
            }
        ];
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/venues/venues.service.ts